export default __webpack_public_path__ + "static/media/contactpic.aae4879d.jpg";